import { type CustomTooltipProps } from "ag-grid-react"
import { Card, CardContent, CardHeader, CardTitle } from "~/components/reusable/Card"

export interface QuantityAlertsTooltipValue {
  tooltipType: "QuantityAlerts"
  /** MOQ violations (severe). */
  violations: string[]
  /** Colli size violations (minor). */
  colliViolations?: string[]
  lockedMessage?: string
  deviationLines?: string[]
  safetyStockLines?: string[]
}

export default function QuantityAlertsTooltip(props: CustomTooltipProps) {
  const value = props.value as QuantityAlertsTooltipValue | undefined
  if (!value) return null

  const {
    violations = [],
    colliViolations,
    lockedMessage,
    deviationLines,
    safetyStockLines,
  } = value
  if (
    violations.length === 0 &&
    !colliViolations?.length &&
    !lockedMessage &&
    !deviationLines?.length &&
    !safetyStockLines?.length
  )
    return null

  const sections: { title: string; lines: string[] }[] = []
  if (violations.length > 0) sections.push({ title: "MOQ violations", lines: violations })
  if (colliViolations?.length)
    sections.push({ title: "Colli size violations", lines: colliViolations })
  if (lockedMessage) sections.push({ title: "Not editable", lines: [lockedMessage] })
  if (deviationLines?.length) sections.push({ title: "Quantity changed", lines: deviationLines })
  if (safetyStockLines?.length)
    sections.push({ title: "Incoming during safety stock", lines: safetyStockLines })

  return (
    <div className="bg-base w-[320px] mr-6 z-10">
      <Card className="w-full">
        {sections.map((section, i) => (
          <div key={section.title}>
            <CardHeader className={i > 0 ? "border-t border-base" : undefined}>
              <CardTitle>{section.title}</CardTitle>
            </CardHeader>
            <CardContent className="text-fg-muted paragraph-sm space-y-1">
              {section.lines.map((line, j) => (
                <p key={j}>{line}</p>
              ))}
            </CardContent>
          </div>
        ))}
      </Card>
    </div>
  )
}
